import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface PaidMediaState {
  filters: {
    campaignStatus?: string[]
    dateRange?: {
      start: string
      end: string
    }
  }
  bulkOperations: {
    selectedCampaigns: string[]
  }
}

const initialState: PaidMediaState = {
  filters: {},
  bulkOperations: {
    selectedCampaigns: [],
  },
}

export const paidMediaSlice = createSlice({
  name: "paidMedia",
  initialState,
  reducers: {
    setFilters: (
      state,
      action: PayloadAction<Partial<PaidMediaState["filters"]>>,
    ) => {
      state.filters = { ...state.filters, ...action.payload }
    },

    clearFilters: state => {
      state.filters = {}
    },

    // Bulk operations for campaigns
    toggleSelectedCampaign: (state, action: PayloadAction<string>) => {
      const campaignId = action.payload
      const index = state.bulkOperations.selectedCampaigns.indexOf(campaignId)
      if (index > -1) {
        state.bulkOperations.selectedCampaigns.splice(index, 1)
      } else {
        state.bulkOperations.selectedCampaigns.push(campaignId)
      }
    },

    clearBulkSelections: state => {
      state.bulkOperations.selectedCampaigns = []
    },

    selectAllCampaigns: (state, action: PayloadAction<string[]>) => {
      state.bulkOperations.selectedCampaigns = action.payload
    },

    resetState: () => initialState,
  },
})

export const {
  setFilters,
  clearFilters,
  toggleSelectedCampaign,
  clearBulkSelections,
  selectAllCampaigns,
  resetState,
} = paidMediaSlice.actions
